import {
  HMDA_INFO_SAVE
} from "../../constants/loan/_hmda_constants";

export const HMDA_INFO_SAVE_ACTION = (value) => ({
  type: HMDA_INFO_SAVE,
  payload: value
});
